import { memo } from 'react';
import { Link } from 'react-router-dom';
import { Layout } from 'antd';
import { useAppSelector } from 'app/hooks';
import { selectUserSignInStatus } from 'services/session/sessionSelectors';
import Menu from 'components/Header/partials/Menu';
import BrandLogo from 'components/BrandLogo';
import If from 'components/If';

// styles
import { QaHeader } from 'testdata/constants';
import styles from './Header.module.scss';

const { Header: LayoutHeader } = Layout;

type HeaderProps = {
  menu?: boolean;
};

function Header({ menu = true }: HeaderProps) {
  const isLogin = useAppSelector(selectUserSignInStatus);

  return (
    <LayoutHeader
      className={styles.container}
      data-qa-selector={QaHeader.containerHeader}
    >
      <Link
        to={isLogin ? '/dashboard' : '/sign-in'}
        data-qa-selector={QaHeader.linkLogo}
      >
        <BrandLogo />
      </Link>
      <If condition={menu}>
        <div className={styles.content}>
          <Menu />
        </div>
      </If>
    </LayoutHeader>
  );
}

export default memo(Header);
